import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { TableMemoryPagination } from '@/services/table-memory-pagination'

export interface TerminalQueryParams {
  key_word: string // 关键词搜索
  page: number // 页码
  limit: number // 每页数量
  sort: string // 排序字段名
  asc: boolean // true-正序，false-逆序
  useMemory: boolean // 是否使用内存数据
  login_status?: number // 登录状态
  permission_name?: string
}

export interface TerminalItem {
  device_id: string // 终端设备id
  computer_name: string // 计算机名
  user_mark: string // 登记用户名
  client_ip: string // 外网IP
  system_ip: string // 内网IP
  auto_intercept_switch: number // 自动拦截开关,1-开启,2-关闭
  ai_intercept_switch: number // AI防骚扰智能引擎开关,1-开启,2-关闭
  popup_count: number // 弹窗数量
  /** 授权状态：0-正常，1-待授权 2-未订阅 */
  auth_status?: number
  group_name?: string
}

export interface ScanOrderOptions {
  execute_type: number,
  device_list: string[],
  group_id: number
}

export interface EngineOrderOptions {
  execute_type: number // 指定执行类型,0-指定终端,1-指定分组, 默认是0
  device_list?: string[] // 终端device列表
  group_id?: number // 分组id,保留
  engine: number // 引擎类型,2-自动拦截，1-AI引擎
  // is_closed: boolean // 是否关闭拦截引擎,true-关闭，false-打开 （不传，只有打开没有关闭的场景）
}
export interface DetailQueryParams {
  page: number // 页码
  limit: number // 每页数量
  sort?: string // 排序规则
  asc?: boolean // 排序,true-正序，false-倒序
  device_id: string // 终端设备id
}

export interface DetailItem {
  soft_id: number // 软件id
  soft_name: string // 软件名称
  intercept_count: number // 拦截次数
  popup_count: number // 弹出次数
  popup_type?: number // 弹窗类型,1-右下角弹泡,2-中间弹泡, 3-捆绑其他软件
  latest_popup_time: number // 最近弹出时间
}

@Injectable()
export class TerminalViewService extends TableMemoryPagination<TerminalQueryParams, TerminalItem> {
  constructor (private http: Http) {
    super()
  }

  isEqual (left: TerminalItem, right: TerminalItem): boolean {
    return left.device_id === right.device_id
  }

  @ParamsClean()
  @InvokeThrottle()
  getListByServer (options: TerminalQueryParams) {
    return this.http
      .post<{
        total: number,
        enable_total: number,
        list: TerminalItem[]
      }>('/popupintercept/terminal-stat', options)
  }

  @ParamsClean()
  @InvokeThrottle()
  fetchDetailList (options: DetailQueryParams) {
    return this.http
      .post<{
        total: number,
        list: DetailItem[]
      }>('/popupintercept/terminal-popups', options)
  }

  @InvokeThrottle()
  scanReport (options: ScanOrderOptions) {
    return this.http
      .post('/popupintercept/popup-scan', options)
  }

  @InvokeThrottle()
  updateEngine (options: EngineOrderOptions) {
    return this.http
      .post('/popupintercept/engine-update', options)
  }
}
